import Cookies from 'js-cookie';

import { BasketCatalogItemSimpleI } from '../../Modules/Basket';
import axios, { axiosClassic } from '../../api/intercepors';
import { API_KEY } from '../../config/api.config';
import {
  getBasketsUrl,
  getSuggestionsUrl,
  getUdateOrg,
} from '../../config/url.config';
import { ICatalogSynchronization } from '../../shared/types/basket';
import { IUpdateOrg, IUpdateOrgReponse } from '../../types/basket';

export const BasketService = {
  async synchronization(catalog_items_basket: BasketCatalogItemSimpleI[]) {
    const sessionToken = localStorage.getItem('st');
    const response = await axios.post<ICatalogSynchronization>(
      getBasketsUrl('/synchronization'),
      {
        catalog_items_basket,
      },
      { headers: { 'session-token': String(sessionToken) } }
    );

    return response;
  },
  async getDetailsItems(catalog_items_ids: number[]) {
    const response = await axiosClassic.post('/catalog-items-basket', {
      catalog_items_ids,
    });
    return response;
  },
  async updateOrg(data: IUpdateOrg) {
    const sessionToken = localStorage.getItem('st');
    const response = await axiosClassic.post<IUpdateOrgReponse, IUpdateOrg>(
      getUdateOrg(''),
      data,
      {
        headers: {
          'session-token': String(sessionToken),
        },
      }
    );
    return response;
  },
  async getSuggestionsData(query: string, count: number = 1) {
    const response = await axiosClassic.post(
      getSuggestionsUrl(),
      {
        query: query,
        count: count,
        locations_boost: [
          {
            kladr_id: '2500000000000', //Приморье в приоритете
          },
        ],
      },
      {
        headers: {
          Accept: 'application/json',
          Authorization: `Token ${API_KEY}`,
        },
      }
    );
    return response.data;
  },
};
